import styles from './SmartBanner.module.scss'
import appStoreIcon from '../../images/appStoreIcon.svg'
import playStoreIcon from '../../images/googlePlayIcon.svg'
import { analyticsTracking } from 'lib/analytics/analytics'
import { useMediaQuery } from '@react-hook/media-query'

const iOSAppLink = 'https://apps.apple.com/ar/app/poap-app/id1567078943'
const androidAppLink = 'https://play.google.com/store/apps/details?id=xyz.poap.app.mobile&hl=es_AR&gl=US'

export enum OperativeSystems {
  ANDROID = 'Android',
  IOS = 'iOS',
}

export const getOperativeSystem = (): string => {
  var userAgent = navigator.userAgent || navigator.vendor

  if (/android/i.test(userAgent)) {
    return OperativeSystems.ANDROID
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return OperativeSystems.IOS
  }

  return 'unknown'
}

export const SmartBanner: React.FC<{}> = () => {
  const isSmallAndUp = useMediaQuery('(min-width: 768px)')
  const isMobileResolution = !isSmallAndUp
  const operativeSystem = getOperativeSystem()

  const openDownloadAppStorePage = (_urlStore: string) => {
    analyticsTracking.claim.trackClickBtnASmartBanner()
    if (_urlStore === iOSAppLink) {
      analyticsTracking.claim.trackClickBtnAppStore()
    }
    if (_urlStore === androidAppLink) {
      analyticsTracking.claim.trackClickBtnPlayStore()
    }
    window.open(_urlStore, '_blank')
  }

  const IOSImage = () => {
    return (
      <img
        src={appStoreIcon}
        className={styles.image}
        alt="App Store Icon"
        onClick={() => openDownloadAppStorePage(iOSAppLink)}
      />
    )
  }

  const AndroidImage = () => {
    return (
      <img
        src={playStoreIcon}
        className={styles.image}
        alt="Play Store Icon"
        onClick={() => openDownloadAppStorePage(androidAppLink)}
      />
    )
  }

  return (
    <div className={styles.container}>
      {isMobileResolution && (operativeSystem == OperativeSystems.IOS ? <IOSImage /> : <AndroidImage />)}
      {!isMobileResolution && (
        <>
          <IOSImage />
          <AndroidImage />
        </>
      )}
    </div>
  )
}
